import React, { createContext, useContext, useState, useEffect } from 'react';
import { auth, db } from '../firebase'
import { doc, getDoc, onSnapshot } from "firebase/firestore";
import { createUserWithEmailAndPassword, onAuthStateChanged, signInWithEmailAndPassword, signOut } from "firebase/auth"


const AuthContext = createContext();

export const useAuth = () => {
  return useContext(AuthContext)
};

export const AuthProvider = ({ children }) => {

  const [currentUser, setCurrentUser] = useState();
  const [loading, setLoading] = useState(true)


  const signup = (email, password) => {
    return createUserWithEmailAndPassword(email, password);
  };

  const login = (email, password) => {
    return signInWithEmailAndPassword(email, password);
  };

  const logout = () => {
    return signOut()
  };

  // const resetPassword = (email) => {
  //   return sendResetPassword(email);
  // };

  const updateEmail = (email) => {
    return currentUser.updateEmail(email);
  };

  const updatePassword = (password) => {
    return currentUser.updatePassword(password);
  };

  const getUserData = async (user) => {
    onSnapshot(doc(db, "users", user.uid), (doc) => {
      const data = doc.data();
      if (data) {
        let userObj = {
          uid: user.uid,
          email: user.email || '',
          name: user.displayName ? user.displayName : data.name ? data.name : user.email,
          roles: data.roles,
          photoURL: user.photoURL || '',
          lastSignInTime: user.metadata.lastSignInTime,
          creationTime: user.metadata.creationTime,
        }
        setCurrentUser(userObj)
        setLoading(false)
      } else {
        console.log("No such document!");
      }
    });
  };

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      if (currentUser) {
        getUserData(currentUser)
      } else {
        setLoading(false)
      }
    })
    return unsubscribe;
  }, [])


  const value = {
    currentUser,
    signup,
    login,
    logout,
    updateEmail,
    updatePassword
  }

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  )
};